import { render, staticRenderFns } from "./SearchInput.vue?vue&type=template&id=20432bf2&scoped=true&lang=pug&"
import script from "./SearchInput.vue?vue&type=script&lang=js&"
export * from "./SearchInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20432bf2",
  null
  
)

export default component.exports